import React, { useState } from 'react';
import { connect } from 'react-redux';
import Router from 'next/router';
import LayerImage from '~/components/Layers/LayerImage/LayerImage';
import Pagination from '~/components/Pagination/Pagination';
import scrollAnimation from '~/utils/scroll-animation';
import { SCORE_TYPE, SCORE_NAME } from '~/utils/constant';
import css from './ServiceScore.less';

const ServiceScore = props => {
  const [layerData, setLayerData] = useState({
    visible: false,
    image: '',
  });

  const updateUrl = payload => {
    const { institution } = props;
    const { comment, id, cid, type } = institution;
    const { page } = comment;
    const href = '/institution/[id]/';
    let as = `/institution/${id}/?p=${payload.page || page}`;
    if (cid) {
      as = `${as}&cid=${cid}`;
    }
    if (type) {
      as = `${as}&type=${type}`;
    }
    // 更新页面路由
    Router.push(href, as, { shallow: true });
  };

  const scrollWithAnimation = () => {
    const serviceScore = document.getElementById('serviceScore');
    const { offsetTop } = serviceScore;
    if (offsetTop) {
      scrollAnimation(offsetTop);
    }
  };

  const onChange = async (current, pageSize) => {
    if (current && pageSize) {
      const { dispatch, institution } = props;
      const { comment } = institution;
      await dispatch({
        type: 'institution/setState',
        payload: {
          comment: {
            ...comment,
            page: current,
          },
        },
      });
      await dispatch({ type: 'institution/getCommentList' });
      scrollWithAnimation();
      updateUrl({ page: current });
    }
  };

  const showLayer = image => {
    if (image) {
      setLayerData({
        image,
        visible: true,
      });
    }
  };

  const hideLayer = () => {
    setLayerData({
      image: '',
      visible: false,
    });
  };

  const { institution } = props;
  const { commentList, comment } = institution;
  const { page, totalItems, total } = comment;
  return (
    <div className={css.contentMain}>
      <p className={css.contentTitle} id="serviceScore">
        服务评分
      </p>
      {commentList.length >= 1 ? (
        <>
          <ul className={css.evaluationList}>
            {commentList.map(item => {
              return (
                <li className={css.evaluationItem} key={item.id.toString()}>
                  <div className={css.userInfo}>
                    <img
                      src={item.user.headimgurl}
                      alt="avatar"
                      className={css.avatar}
                    />
                    <div>
                      <p className={`text-hidden-one ${css.name}`}>
                        <span>{item.user.nickname}</span>
                        {/* 点评了 鱿鱼圈儿乳房护理正价单次套餐仅上门服务 */}
                      </p>
                      <p className={css.date}>{item.created_on_str}</p>
                    </div>
                  </div>

                  <p className={css.evaluationMsg}>{item.message}</p>

                  {item.media.length >= 1 ? (
                    <div className={css.imgList}>
                      {item.media.map((imgItem, indexs) => {
                        return (
                          <img
                            src={imgItem.media_file}
                            alt="img"
                            className={css.imgItem}
                            key={indexs.toString()}
                            onClick={() => showLayer(imgItem.media_file)}
                          />
                        );
                      })}
                    </div>
                  ) : null}

                  {item.score_data ? (
                    <>
                      <div className={css.scoreBox}>
                        <span className={`dinMedium ${css.total}`}>
                          {item.score_data.total_score}
                        </span>
                        <p className={css.right}>
                          <span className={css.scoreName}>
                            最高分：{item.score_data.max_score.name}
                          </span>
                          <span className={`dinMedium ${css.scoreNum}`}>
                            {item.score_data.max_score.score}
                          </span>
                          <span className={css.scoreLine}> </span>
                          <span className={css.scoreName}>
                            最低分：{item.score_data.min_score.name}
                          </span>
                          <span className={`dinMedium ${css.scoreNum}`}>
                            {item.score_data.min_score.score}
                          </span>
                        </p>
                      </div>

                      {/* 评分明细 */}
                      <ul className={css.scoreDetailBox}>
                        {Object.keys(SCORE_TYPE).map(key => {
                          return (
                            <li className={css.scoreItem} key={key}>
                              <p className={css.scoreTitle}>
                                {SCORE_NAME[key]}
                              </p>
                              <div className={css.scoreShow}>
                                <div className={css.progress}>
                                  <span
                                    style={{
                                      width: `${(item.score_data[
                                        SCORE_TYPE[key]
                                      ] /
                                        10) *
                                        160}px`,
                                    }}
                                  >
                                    {' '}
                                  </span>
                                </div>
                                <p className={`${css.scoreNum} dinMedium`}>
                                  {item.score_data[SCORE_TYPE[key]]}
                                </p>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  ) : null}
                </li>
              );
            })}
          </ul>
          {total > 1 ? (
            <div className={css.pagination}>
              <Pagination
                defaultCurrent={page}
                current={page}
                onChange={onChange}
                total={totalItems}
              />
            </div>
          ) : null}
        </>
      ) : (
        <p className={css.noContent}>更多精彩内容还在努力完善中</p>
      )}
      <LayerImage
        visible={layerData.visible}
        image={layerData.image}
        showLayer={showLayer}
        hideLayer={hideLayer}
      />
    </div>
  );
};

export default connect(({ institution }) => ({
  institution,
}))(ServiceScore);
